import React from 'react';
import AdminLayout from './AdminLayout';
import EventTypeAdmin from '../../components/events/EventTypeAdmin';

export default function AdminEventTypesPage() {
    return (
        <AdminLayout title="Event Types" description="Configure event types for scheduling">
            <EventTypeAdmin />
        </AdminLayout>
    );
}
